import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import arrowLeft from "../assets/images/arrow-left.png";
import teacher1 from "../assets/images/teacher1.webp";
import teacher2 from "../assets/images/teacher2.webp";
import teacher3 from "../assets/images/teacher3.webp";
import { getTeacherDetails } from '../services/TeacherApi';
import LoadingSpinner from './LoadingSpinner';
import config from '../config/config';

const TeacherDetails = () => {
  const { id: teacherId } = useParams();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const programId = location.state?.programId || null;

  useEffect(() => {
    fetchTeacherDetails();
  }, []);

  const fetchTeacherDetails = async () => {
    try {
      const response = await getTeacherDetails(teacherId);
      setTeacher(response.data || {});
    } catch (error) {
      toast.error("Failed to fetch teacher details");
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    if (programId) {
      navigate(`/teachers/${programId}`);
    } else {
      navigate(-1); // Fallback if no programId
    }
  };

  if (loading) return <LoadingSpinner />;
  if (!teacher) return <p>No details found.</p>;

  return (
    <div className='app-container mobile-bottom'>
      <Container>
        <div className='breadcrum bg_light_yellow mb-3 teachers_strip'>
          <h2 className='d-flex align-items-center mb-0'>
            <img src={arrowLeft} onClick={goBack} width={18} className='me-2' alt="link" />
          </h2>
        </div>

        <div className='teacher-details rounded-4 text-center p-3'>
          <div className='teacherDP bg_dark_green mb-3'>
            <img
              src={`${config.Image_Base_URL}${teacher.profile_pic_url}`}
              className="w-100 h-100 rounded-50"
              alt={teacher.name}
            />
          </div>
          <h6 className='text-danger fs-16'>{teacher.name}</h6>
          <small className='fs-10 bg-secondary bg-opacity-25 rounded-4 px-2 py-1'>{teacher.designation}</small>
          <p className='fs-12 mt-3 mb-0'>{teacher.bio}</p>
        </div>
        <Row className='teacher-row justify-content-center my-4 text-center fs-12'>
          <Col xs='6' className='mb-3' >
            <div className='teacherSub'>
              <img src={teacher3} alt="link" />
              <p className='mb-0'>{teacher.experiences}</p>
            </div>
          </Col>
          <Col xs='6' className='mb-3'>
            <div className='teacherSub'>
              <img src={teacher2} alt="link" />
              <p className='mb-0'>{teacher.awards}</p>
            </div>
          </Col>
          <Col xs='6' className='mb-3'>
            <div className='teacherSub'>
              <img src={teacher1} alt="link" />
              <p className='mb-0'>{teacher.certifications}</p>
            </div>
          </Col>
        </Row>
      </Container >
    </div >
  );
}

export default TeacherDetails;
